<script lang="ts">
  import Spacer from "@/components/spacer.svelte";
  import { Container } from "sveltestrap";

  function ev영상(video_url, title) {
    const element = document.getElementById("moviebg-wrap");
    element.style.display = "block";

    setTimeout(() => {
      element.style.opacity = "1";
      document.getElementById(
        "ytvideo-container"
      ).innerHTML = `<iframe width='100%'' height='100%'
      src='https://www.youtube.com/embed/${video_url}'
      frameborder='0' allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture'
      allowfullscreen='false'
      style='z-index: 99; top: 0; left: 0; position: absolute; width: 100%; height: 100%;'></iframe>`;
    }, 200);
  }

  function closeyt() {
    const element = document.getElementById("moviebg-wrap");
    element.style.opacity = "0";
    setTimeout(() => {
      element.style.display = "none";
      document.getElementById("ytvideo-container").innerHTML = "";
    }, 500);
  }
</script>

<Container>
  <div class="mainview">
    <div class="text-center my-5">
      <h1>
        농업의 기준 '반딧불이'로<br />여유로운 일상을
      </h1>
      <Spacer size="1rem" />
      <div>
        반딧불이는 우리의 소중한 작물을 키우시는<br />농장주님을 위해 더
        노력하겠습니다.
      </div>
    </div>

    <div class="text-center movie">
      <img
        on:click={() => ev영상("nS95eZ4MeL0", "반딧불이 스마트팜 설치후기")}
        src="/images/main/media_new.jpg"
        alt="스마트팜 소개영상"
      />
    </div>
  </div>
  <!-- 영상 이미지 클릭시 유튜브 영상 팝업 -->
  <div class="moviebg-wrap" id="moviebg-wrap">
    <div class="vid-wrap">
      <div class="closeyt" on:click={closeyt}>닫기</div>
      <div class="yt-title">반딧불이 스마트팜 설치후기</div>
      <div class="ytvideo-container" id="ytvideo-container" />
    </div>
  </div>
</Container>

<style lang="scss">
  img {
    width: 70%;
    cursor: pointer;
  }
  .moviebg-wrap {
    display: none;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    z-index: 99;
    background-color: rgba(0, 0, 0, 0.71);
    height: 100%;
    transition: width 2s ease 0s, height 2s ease 0s, background-color 2s ease 0s,
      transform 2s ease 0s, opacity 1s;
    opacity: 0;
  }
  .vid-wrap {
    width: 100%;
    max-width: 1080px;
    border-radius: 30px;
    background-color: #f0f0f0;
    padding: 60px 40px 60px 40px;
    box-sizing: border-box;
    box-shadow: 0px 8px 33px #999;
    transform: translate(-50%, -50%);
    position: absolute;
    top: 50%;
    left: 50%;
  }
  .yt-title {
    position: absolute;
    top: 4%;
    left: 50%;
    transform: translate(-50%, 0%);
    font-size: 24px;
    line-height: 24px;
    width: 400px;
    text-align: center;
  }
  .ytvideo-container {
    position: relative;
    width: 100%;
    height: auto;
    padding-top: 50%;
  }
  .closeyt {
    position: absolute;
    top: 3%;
    left: 93%;
    cursor: pointer;
  }
</style>
